import { render, staticRenderFns } from "./BoxButtonCreatePixKey.vue?vue&type=template&id=7f50d245&"
var script = {}
import style0 from "./BoxButtonCreatePixKey.vue?vue&type=style&index=0&id=7f50d245&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports